import React from 'react';
import { useRecoilState } from 'recoil';
import { modalState } from '../../../recoil/atoms/modal.atom';
import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  CloseButton,
  ModalBody,
  SubmitButton,
  NextPageButton,
  StepsBox,
} from './index.stlyed';
import { Steps } from 'antd';

const Modal = () => {
  const [modal, setModal] = useRecoilState(modalState);
  const { Step } = Steps;
  const isSinglePage = Object.keys(modal.pageData || {}).length === 1; // 단일 페이지 확인

  if (!modal.isOpen) return null;

  const currentPageData = modal.pageData?.[modal.currentPage ?? 0];

  const handleSubmit = () => {
    if (modal.onSubmit) {
      modal.onSubmit();
    }
    setModal({ ...modal, isOpen: false });
  };

  const handleNextPage = () => {
    setModal(prevModal => ({
      ...prevModal,
      currentPage: (prevModal.currentPage ?? 0) + 1,
    }));
  };

  return (
    <ModalOverlay>
      <ModalContainer>
        <ModalHeader>
          <ModalTitle>{currentPageData?.title || modal.title}</ModalTitle>
          <CloseButton onClick={() => setModal({ ...modal, isOpen: false })}>X</CloseButton>
        </ModalHeader>
        {!isSinglePage && (
          <StepsBox>
            <Steps current={(modal.currentPage ?? 0) - 1}>
              {modal.pageData &&
                Object.entries(modal.pageData).map(([page, { title }], i) => (
                  <Step
                    key={i}
                    title={title}
                    onClick={() => setModal(prevModal => ({ ...prevModal, currentPage: Number(page) ?? 0 }))}
                  />
                ))}
            </Steps>
          </StepsBox>
        )}
        <ModalBody>{currentPageData?.content}</ModalBody>
        {modal.showNextPageButton && <NextPageButton onClick={handleNextPage}>다음</NextPageButton>}
        {modal.showSubmitButton && <SubmitButton onClick={handleSubmit}>ADD</SubmitButton>}
      </ModalContainer>
    </ModalOverlay>
  );
};

export default Modal;
